import { Bank } from "../../model"

export function contains(banks: Bank[], bank: Bank): boolean {
	return banks.some(b => equal(b, bank))
}

export function equal(bank1: Bank, bank2: Bank): boolean {
	return (!bank1 && !bank2) || bank1 && bank2 && bank1.id === bank2.id
}

/**
 * Trie les {@link Bank}s du tableau par leur `label` en place et retourne ledit
 * tableau.
 * @param banks
 */
export function sortByLabel(
	banks: Bank[],
	order: "ASC" | "DESC" = "ASC"
): Bank[] {
	return banks.sort((b1, b2) => {
		let value = 0
		if (!b1 && b2) value = -1
		if (b1 && !b2) value = 1
		if (b1 && b2)
			value = b1.label.toUpperCase() > b2.label.toUpperCase() ? 1 : -1

		return "ASC" === order ? value : -value
	})
}



// WEBPACK FOOTER //
// ./src/domain/sfp/bank-domain.ts